import { MEDIA_TYPE, VIDEO_TYPE } from '../../../react/features/base/media/constants';
import {
    getTrackByMediaTypeAndParticipant,
    getVideoTrackByParticipant
} from '../../../react/features/base/tracks/functions.any';
import {
    getParticipantById
} from '../../../react/features/base/participants/functions';
import LargeVideoManager from './LargeVideoManager';
import { VIDEO_CONTAINER_TYPE } from './VideoContainer';

export default function(obj) {
    let largeVideos = [];
    let eventEmitter = null;

    const VideoLayout = Object.assign({}, obj);

    // live stream object
    let includedContainer;
    let $sharedVideo;


    /**
     * flipX state of the localVideo
     */
    const localFlipX = null;

    const methods = {
        init(emitter) {
            eventEmitter = emitter;
            VideoLayout.init.call(this, emitter);
        },

        initLargeVideo() {
            this._resetLargeVideo();

            largeVideos = APP.wildix.wizy.screenKeys.map(item => {
                const largeVideo = new LargeVideoManager(eventEmitter, item);

                if (localFlipX) {
                    largeVideo.onLocalFlipXChange(localFlipX);
                }
                largeVideo.updateContainerSize();

                return largeVideo;
            });

            $('#videospace-container').append('<div id="sharedVideo"><div id="sharedVideoIFrame"/></div>');
            $sharedVideo = $('#sharedVideo');
            $sharedVideo.css({ width: `${100 / APP.wildix.wizy.screenKeys.length}%` });
        },

        /**
         * Cleans up any existing largeVideos instances.
         *
         * @private
         * @returns {void}
         */
        _resetLargeVideo() {
            largeVideos.forEach(item => {
                item.destroy();
            });

            largeVideos = [];
        },

        /**
         * Sets the audio level of the video elements associated to the given id.
         *
         * @param id the video identifier in the form it comes from the library
         * @param lvl the new audio level to update to
         */
        setAudioLevel(id, lvl) {
            VideoLayout.setAudioLevel.call(this, id, lvl);
        },

        /**
         * Resizes the video area.
         */
        resizeVideoArea() {
            largeVideos.forEach(item => {
                item.updateContainerSize();
                item.resize(false);
            });
        },

        updateAllVideos() {
            largeVideos.forEach(item => {
                if (item.id) {
                    if (includedContainer && includedContainer.videoItemId === item.id) {
                        return;
                    }
                    item.updateLargeVideo(item.id, true);
                }
            });
        },

        updateLargeVideo(ids, forceUpdate, forceStreamToReattach = false) {

            for (let idx = 0; idx < ids.length; idx++) {

                const id = ids[idx];
                const videoItem = largeVideos[idx];

                if (!videoItem) {
                    continue;
                }


                if (!id) {
                    videoItem.container.style.opacity = '0';
                } else {
                    const opacityVal = videoItem.container.style.opacity;

                    if (Number(opacityVal) === 0) {
                        videoItem.container.style.opacity = 1;
                    }

                    const currentContainer = videoItem.getCurrentContainer();
                    const currentContainerType = videoItem.getCurrentContainerType();
                    const isOnLarge = videoItem.id === id;
                    const state = APP.store.getState();
                    const participant = getParticipantById(state, id);
                    const videoTrack = getVideoTrackByParticipant(state, participant);
                    const videoStream = videoTrack?.jitsiTrack;

                    if (videoStream && forceStreamToReattach) {
                        videoStream.forceStreamToReattach = forceStreamToReattach;
                    }

                    if (isOnLarge && !forceUpdate
                        && LargeVideoManager.isVideoContainer(currentContainerType)
                        && videoStream) {
                        const currentStreamId = currentContainer.getStreamID();
                        const newStreamId = videoStream?.getId() || null;

                        // FIXME it might be possible to get rid of 'forceUpdate' argument
                        if (currentStreamId !== newStreamId) {
                            forceUpdate = true; // eslint-disable-line no-param-reassign
                        }
                    }

                    if (!isOnLarge || forceUpdate) {
                        const videoType = this.getRemoteVideoType(id);

                        videoItem.updateLargeVideo(
                            id,
                            videoStream,
                            videoType || VIDEO_TYPE.CAMERA
                        ).catch(() => {
                            // do nothing
                        });
                    }
                }
            }


            // if some participant stream video
            if (includedContainer) {
                const el = largeVideos.find(item => item.id === includedContainer.container.id);

                if (el) {
                    if ($sharedVideo.length) {
                        const { left } = el.$container[0].getBoundingClientRect();

                        $sharedVideo.css({
                            display: 'block',
                            left: `${left}px`
                        });
                    }
                } else {
                    $sharedVideo.css({ display: 'none' });
                }
            }
        },

        addLargeVideoContainer(type, container) {
            if (!includedContainer) {
                largeVideos[0].addContainer(type, container);
                includedContainer = {
                    container,
                    type
                };
            }
        },

        removeLargeVideoContainer(type) {
            const largeVideo = largeVideos.find(item => item.id === includedContainer.container.id);

            includedContainer = null;
            $sharedVideo.css({ display: 'none' });
            if (largeVideo && largeVideo.containers[type]) {
                largeVideo.removeContainer(type);
            }
        },

        /**
         * @returns Promise
         */
        showLargeVideoContainer(type, show) {
            if (!largeVideos[0]) {
                return Promise.reject();
            }

            const isVisible = this.isLargeContainerTypeVisible(type);

            if (isVisible === show) {
                return Promise.resolve();
            }

            const currentId = largeVideos[0].id;
            let oldSmallVideo;

            if (currentId) {
                oldSmallVideo = this.getSmallVideo(currentId);
            }

            let containerTypeToShow = type;

            // if we are hiding a container and there is focusedVideo
            // (pinned remote video) use its video type,
            // if not then use default type - large video

            if (!show) {
                const pinnedId = this.getPinnedId();

                if (pinnedId) {
                    containerTypeToShow = this.getRemoteVideoType(pinnedId);
                } else {
                    containerTypeToShow = VIDEO_CONTAINER_TYPE;
                }
            }

            return largeVideos[0].showContainer(containerTypeToShow)
                             .then(() => {
                                 if (oldSmallVideo) {
                                     oldSmallVideo && oldSmallVideo.updateView();
                                 }
                             });
        },

        isLargeContainerTypeVisible(type) {
            return largeVideos[0] && largeVideos[0].state === type;
        },

        /**
         * Returns the wrapper jquery selector for the largeVideo
         * @returns {JQuerySelector} the wrapper jquery selector for the largeVideo
         */
        getLargeVideoWrapper() {
            return largeVideos[0] ? largeVideos[0].$wrapper : undefined;
        },

        /**
         * Triggers an update of large video if the passed in participant is
         * currently displayed on large video.
         *
         * @param {string} participantId - The participant ID that should trigger an
         * update of large video if displayed.
         * @param {boolean} force - Whether or not the large video update should
         * happen no matter what.
         * @returns {void}
         */
        _updateLargeVideoIfDisplayed(participantId, force = false) {
            this.updateLargeVideo(APP.store.getState()['wizyconf/large-video'].participantIds, force);
        }
    };

    return Object.assign(obj, methods);
}
